// extracted by mini-css-extract-plugin
export default {"container":"Cargando_container__99BNb","loader":"Cargando_loader__jqheJ"};